import { render, staticRenderFns } from "./BarcodeReaderV2.vue?vue&type=template&id=20106ee8&scoped=true"
import script from "./BarcodeReaderV2.vue?vue&type=script&lang=ts"
export * from "./BarcodeReaderV2.vue?vue&type=script&lang=ts"
import style0 from "./BarcodeReaderV2.vue?vue&type=style&index=0&id=20106ee8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20106ee8",
  null
  
)

export default component.exports